import { render, staticRenderFns } from "./AlertCard.vue?vue&type=template&id=1c0bf450"
import script from "@/components/alert-card/AlertCard.ts?vue&type=script&lang=ts&external"
export * from "@/components/alert-card/AlertCard.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/alert-card/alert-card.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports